(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/animations.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/animations.js');
"use strict";


const removeListItem = el => {
  const tl = gsap.timeline({
    paused: true
  });
  tl.to(el, {
    height: 0,
    scaleY: 0,
    opacity: 0,
    duration: 0.2
  });
  return tl;
};
const addListItem = el => {
  const tl = gsap.timeline({
    paused: true
  });
  tl.fromTo(el, {
    y: -30,
    opacity: 0
  }, {
    opacity: 1,
    y: 0,
    clearProps: 'all',
    duration: 0.2
  });
  return tl;
};
const updateListItem = el => {
  const tl = gsap.timeline({
    paused: true
  });
  tl.fromTo(el, {
    scale: 1.3,
    opacity: 0.6,
    rotation: gsap.utils.random(-15, 15, 1)
  }, {
    opacity: 1,
    scale: 1,
    rotation: 0,
    clearProps: 'all',
    ease: 'elastic.out',
    duration: 0.7
  });
  return tl;
};
svs.tickets_giftshop.gift.giftform.cart.animations = {
  removeListItem,
  addListItem,
  updateListItem
};

 })(window);